<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button type="primary" @click="create(null)" icon="el-icon-plus">添加</el-button>
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template slot-scope="{row}">
            <el-button type="text" icon="el-icon-plus" @click="create(row)" />
            <el-button type="text" icon="el-icon-edit" @click="edit(row)" />
            <el-button type="text" icon="el-icon-delete" @click="del(row)" />
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload"></edit-dialog>
  </div>
</template>
<script>
import list from "@/components/sys/menu/list";
import editDialog from "@/components/sys/menu/editDialog";
import curdMixins from "@/mixins/curd";

export default {
  name: "menus",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
  },
  methods: {
    create(row = null) {
      let length = 0;
      if (row == null) {
        length = this.$refs.list.$refs.list.data.length;
      } else {
        length = row.children ? row.children.length : 0;
      }
      this.$refs.editDialog.open().then((that) => {
        if (row) {
          that.setParent(row);
        }
        that.setSn(length);
      });
    },
    edit(row) {
      // if (row.Pid != 0) {
      //   this.$refs.list.sourceData.forEach((item) => {
      //     if (item.MenuId == row.Pid) {
      //       row.Pid = item.MenuId;
      //       row.PName = item.MenuName;
      //     }
      //   });
      // }
      this.$refs.editDialog.openEditById(row.MenuId);
    },
    del(row) {
      this.$refs.list.delete(row).then(() => {
        this.reload();
      });
    },
  },
};
</script>